var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    (_vm.locale === "en" || _vm.locale === "de") &&
    _vm.index === 6 &&
    _vm.currentPage === 1 &&
    _vm.bannerInsights.length > 0
      ? _c(
          "div",
          { staticClass: "insightBanner__container" },
          [
            _vm.checkInArray("market")
              ? _c("insight-banner", {
                  attrs: {
                    insight: true,
                    "banner-name": "market",
                    "banner-icon": "#iconMarketInsightsSquare",
                    "banner-title": "Market Insights",
                    "banner-content": _vm.trans("MARKET_INSIGHT_TEXT"),
                    "banner-content-count": _vm.trans(
                      "MARKET_INSIGHT_TEXT_WITH_COUNT",
                      { "{count}": _vm.resultCounterMarket }
                    ),
                    "banner-content-single-count": _vm.trans(
                      "MARKET_INSIGHT_TEXT_WITH_SINGLE_COUNT"
                    ),
                    "banner-link-title": _vm.trans("MARKET_INSIGHT_LINK"),
                    "banner-link": true,
                    "insight-result": true,
                    "insight-result-counter": _vm.resultCounterMarket,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkInArray("consumer")
              ? _c("insight-banner", {
                  attrs: {
                    insight: true,
                    "banner-name": "gcs",
                    "banner-icon": "#iconConsumerInsightsSquare",
                    "banner-title": "Consumer Insights",
                    "banner-content": _vm.trans("CONSUMER_INSIGHT_TEXT"),
                    "banner-content-count": _vm.trans(
                      "CONSUMER_INSIGHT_TEXT_WITH_COUNT",
                      { "{count}": _vm.resultCounterConsumer }
                    ),
                    "banner-content-single-count": _vm.trans(
                      "CONSUMER_INSIGHT_TEXT_WITH_SINGLE_COUNT"
                    ),
                    "banner-link-title": _vm.trans("CONSUMER_INSIGHT_LINK"),
                    "banner-link": true,
                    "insight-result": true,
                    "insight-result-counter": _vm.resultCounterConsumer,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkInArray("default")
              ? _c("insight-banner", {
                  attrs: {
                    insight: false,
                    "banner-title": "Explore more insights",
                    "banner-content": "No insights content",
                    "banner-link": false,
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "text--linkReset resultList__itemBox",
        class: { "itemContainer--editorial": _vm.promoted },
        attrs: {
          "data-gtm": `searchItem--${_vm.item.idcontent}`,
          target:
            _vm.item.identity === "54" || _vm.item.identity === "55"
              ? "_blank"
              : "_self",
          href: _vm.path(_vm.item),
        },
        on: {
          keydown: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.addDataLayer.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "right", 39, $event.key, [
                  "Right",
                  "ArrowRight",
                ])
              )
                return null
              if ("button" in $event && $event.button !== 2) return null
              return _vm.changeFocus.apply(null, arguments)
            },
          ],
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "itemContent text-ellipsis",
            attrs: {
              "data-gtm": `searchResult__page${_vm.currentPage}--position${
                _vm.absolutePosition
              }${_vm.promoted ? " searchResult__promotion" : ""}`,
            },
            on: { click: _vm.addDataLayer },
          },
          [
            _c("span", {
              staticClass: "item__icon iconSprite resultList__item",
              class: [`iconSprite--${_vm.getIcon(_vm.item)}`],
            }),
            _vm._v(" "),
            _c("span", { staticClass: "item__text" }, [
              _vm._v(
                _vm._s(_vm.getGroupType(_vm.item)) +
                  " " +
                  _vm._s(
                    _vm.item.tstampreleased || _vm.item.tstampupdated
                      ? " | "
                      : ""
                  ) +
                  "  " +
                  _vm._s(
                    _vm.item.tstampreleased || _vm.item.tstampupdated
                      ? _vm.formatDate(
                          _vm.item.tstampreleased
                            ? _vm.item.tstampreleased
                            : _vm.item.tstampupdated
                        )
                      : ""
                  )
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "itemContent__text",
                class: {
                  "text-ellipsis": _vm.promoted,
                  itemContent__textWithIcon:
                    _vm.item.identity === "54" || _vm.item.identity === "55",
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.getTitle(_vm.item)) +
                    "\n                "
                ),
                _vm.item.identity === "54" || _vm.item.identity === "55"
                  ? _c(
                      "svg",
                      {
                        staticClass: "item__icon--newTab",
                        attrs: {
                          width: "16",
                          height: "16",
                          "aria-hidden": "true",
                        },
                      },
                      [_c("use", { attrs: { href: "#iconNewTab" } })]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "itemContent__subline resultList__itemSubHeadline",
              },
              [
                _vm.contentOwner && _vm.owner
                  ? _c("span", [
                      _c("span", { staticClass: "text-bold" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.owner) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" –\n                "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.newSubtitle) },
                }),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _vm.promoted
          ? _c("div", { staticClass: "itemContent__editorialWrapper" }, [
              _c("span", { staticClass: "itemContent__editorial" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.trans("EDITORIAL_PICK")) +
                    "\n            "
                ),
              ]),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }